<template>
    <el-dialog title="导入" width="640px" :model-value="modelValue" @close="closed" :close-on-click-modal="false">
        <el-form ref="formRef" :model="formData" :rules="formRules" label-width="120px" style="max-width: 540px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="导入人员">
                        <span>{{ userNameList }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="所属部门" prop="department">
                        <el-tree-select
                            v-model="formData.department"
                            :data="deptList"
                            check-strictly
                            :render-after-expand="false"
                            value-key="name"
                            node-key="id"
                            placeholder="请选择所属部门"
                            :default-expanded-keys="['']"
                            style="width: 100%"
                            :props="{ label: 'name' }"
                        >
                            <template #default="{ data }">
                                {{ data.name }}
                            </template>
                        </el-tree-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="角色" prop="roles">
                        <el-select v-model="formData.roles" multiple collapse-tags placeholder="请选择角色">
                            <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, ref, watch } from 'vue'
import { getRoleOptionLists } from '@/api/role'
import { ElMessage } from 'element-plus'
import { getPostOptions } from '@/api/post.js'
import { batchiImport } from '@/api/sync-users.js'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    userList: {
        type: Array,
        required: true
    },
    deptList: {
        type: Array,
        required: true
    }
})
// const statusViewMap = ref({ '-1': '欠费', 0: '禁用', 1: '启用' })
const emits = defineEmits(['update:modelValue', 'updateForm'])
const submitLoading = ref(false)
const formRef = ref(null)
const formData = ref({
    department: '',
    roles: []
})
// 表单验证

const formRules = ref({
    department: [
        {
            required: true,
            message: '请选择所属部门',
            trigger: 'blur'
        }
    ],
    roles: [
        {
            required: true,
            message: '请选择用户角色',
            trigger: 'change'
        }
    ]
})

const dialogTitle = ref('')

const closed = () => {
    emits('update:modelValue', false)
    dialogTitle.value = ''
    formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    await doAddSyncUser()
}
// 角色列表
const roleList = ref([])
const getRoleListsFun = async () => {
    roleList.value = await getRoleOptionLists({})
}
getRoleListsFun()

// 岗位列表
const postList = ref([])
const getPostOptionsFun = async () => {
    postList.value = await getPostOptions()
}
getPostOptionsFun()

// 添加导入
const doAddSyncUser = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const lists = props.userList.map((item) => item.user_id)
        const err = await batchiImport({ department: formData.value.department, roles: formData.value.roles, lists }).catch(
            (err) => {
                submitLoading.value = false
                return err
            }
        )
        if (err) return
        // 人员添加成功
        emits('updateForm')
        ElMessage.success('导入成功')
        submitLoading.value = false
        closed()
    })
}
const userNameList = ref()
// 获取导入人员详情
const handleUserList = () => {
    userNameList.value = props.userList.map((item) => item.user_name).join('，')
}

watch(
    () => props.userList.length,
    (newVal) => {
        if (newVal) {
            handleUserList()
        } else {
            // 置空
            formData.value = {
                department: '',
                roles: []
            }
        }
    }
)
</script>

<style scoped></style>
